import React from "react";
import ImageShape from "../../Common/ImageShape/ImageShape";
import slide2 from "../../../assets/UMSImage/about-us-billing.png";
import dot from "../../../assets/UMSImage/dot.png";
import "./specialize.scss";
import { Specializes } from "../../../constants/Home";
import Button from "../../Common/Button/Button";

const Specialize = () => {
  return (
    <>
      <section id="specialize-wrapper">
        <div className="row">
          <div className="col-md-6 bg-image">
          <img src={slide2} alt="" />
          </div>
          <div className="col-md-6 specialize">
            <p className="title">ABOUT-US</p>
            <h2 className="heading">
              We Specialize in <span>Medical Billing</span>{" "}
            </h2>
            <p>
              Our team specializes in medical billing, ensuring that healthcare
              providers receive timely and accurate reimbursement for their
              services. With years of experience in the field, we are
              well-versed in the complex world of medical coding and billing
              regulations. Our services include claim submission, follow-up, and
              appeals to maximize revenue and minimize the risk of denied
              claims. Let us handle the administrative burden of medical billing
              so that healthcare providers can focus on what they do best –
              providing high-quality care to their patients.
            </p>
            {Specializes?.map((item) => {
              return (
                <>
                  <div className="options">
                    <img src={item?.image} alt="" />
                    <span>{item?.title}</span>
                  </div>
                </>
              );
            })}
            <div className="mb-5">
              <Button id="arrow-wrapper-right" >
                Get a Quote
              </Button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Specialize;
